(() => {
  const root = document.getElementById('sharbatly-claims');
  if (!root) return;

  const apiBaseUrl = (root.dataset.apiBaseUrl || '').replace(/\/$/, '');
  const mockMode = root.dataset.mockMode === 'true';

  const isArabic =
    window.location.pathname.startsWith('/ar') ||
    document.documentElement.lang?.toLowerCase().startsWith('ar') ||
    document.documentElement.dir === 'rtl';

  const translations = {
    en: {
      eyebrow: 'Customer Support',
      title: 'Submit a Claim',
      subtitle: 'We are sorry there was an issue with your order. Please submit the details below so our team can review your claim fairly.',

      info_order_title: 'Order details required',
      info_order_text: 'Keep your order number and phone/email ready.',
      info_evidence_title: 'Clear evidence needed',
      info_evidence_text: 'Capture product photos/videos with the order label or invoice.',
      info_review_title: 'Fair review process',
      info_review_text: 'Our team will review and respond after verification.',

      step_verify: 'Verify Order',
      step_details: 'Claim Details',
      step_evidence: 'Evidence',
      step_submit: 'Submit',

      verify_heading: 'Find your order',
      verify_help: 'Enter your order number and the phone or email used for the order.',
      order_number: 'Order number',
      phone_email: 'Phone or email',
      find_order: 'Find my order',

      claim_details_heading: 'Select affected product',
      claim_details_help: 'Only products from your order can be selected.',
      affected_product: 'Affected product',
      select_product: 'Select product',
      claim_reason: 'Claim reason',
      select_reason: 'Select reason',
      reason_damaged: 'Damaged product',
      reason_spoiled: 'Spoiled product',
      reason_wrong: 'Wrong item received',
      reason_missing: 'Missing item',
      reason_quality: 'Poor quality',
      reason_quantity: 'Quantity issue',
      reason_other: 'Other',
      affected_quantity: 'Affected quantity',
      description: 'Describe the issue',

      evidence_heading: 'Capture evidence',
      evidence_help: 'Please capture clear photos or videos using your camera. Gallery or computer file upload is not allowed.',
      evidence_label_title: '1. Product with order label or invoice',
      evidence_label_help: 'Show the affected product together with the order label or invoice.',
      evidence_closeup_title: '2. Close-up of the issue',
      evidence_closeup_help: 'Show a clear close-up of the damaged, spoiled, wrong, missing, or poor-quality item.',
      evidence_video_title: '3. Live video required',
      evidence_video_help: 'For this claim, a live video is required to complete the review.',
      take_photo: 'Take photo',
      record_video: 'Record video',
      record_live_video: 'Record live video',
      camera_required_note: 'Camera capture is required. Gallery or computer file upload is not allowed.',
      live_camera_required_note: 'Live camera video is required. Gallery or computer file upload is not allowed.',
      capture_photo: 'Capture photo',
      cancel: 'Cancel',
      start_recording: 'Start recording',
      stop_recording: 'Stop recording',
      retake_photo: 'Retake photo',
      record_again: 'Record again',

      review_heading: 'Review and submit',
      claim_notice: 'To review claims fairly, Sharbatly.club may require photos or videos showing the affected product together with the order label or invoice. Claims with unclear, edited, reused, fabricated, misleading, or unverifiable evidence may be rejected. Sharbatly.club reserves the right to restrict or suspend linked accounts, cancel orders, recover improperly obtained refunds or credits, and take further action under its Terms & Conditions and applicable laws.',
      confirm_accuracy: 'I confirm that the information and evidence submitted are accurate and relate to this order.',

      back: 'Back',
      continue: 'Continue',
      submit_claim: 'Submit claim',

      success_heading: 'Claim submitted successfully',
      success_text: 'Your claim is under review. Please keep the affected product, packaging, order label, and invoice until our team completes the review.',
      claim_id: 'Claim ID',

      required_fields: 'Please complete all required fields.',
      order_not_found: 'We could not verify this order. Please check the order number and phone/email.',
      outside_window: 'This order is outside the allowed claim window.',
      upload_required: 'Please capture the required evidence using your camera.',
      verifying: 'Verifying...',
      submitting: 'Submitting...',
      uploading: 'Uploading evidence...',
      verified: 'Order verified successfully.',
      max_quantity: 'Affected quantity cannot be more than ordered quantity.',
      file_selected: 'Captured file:',
      camera_not_supported: 'Camera is not supported on this browser. Please open this page on a mobile browser.',
      video_not_supported: 'Video recording is not supported on this browser. Please open this page on a mobile browser.',
      camera_permission_required: 'Camera permission is required to submit claim evidence.',
      capture_failed: 'Could not capture photo. Please try again.',

      order: 'Order',
      delivered: 'Delivered',
      city: 'City',
      product: 'Product',
      reason: 'Reason',
      quantity: 'Quantity',
      evidence: 'Evidence'
    },

    ar: {
      eyebrow: 'خدمة العملاء',
      title: 'تقديم مطالبة',
      subtitle: 'نأسف لوجود مشكلة في طلبك. يرجى تعبئة التفاصيل أدناه حتى يتمكن فريقنا من مراجعة المطالبة بشكل عادل.',

      info_order_title: 'تفاصيل الطلب مطلوبة',
      info_order_text: 'يرجى تجهيز رقم الطلب ورقم الجوال أو البريد الإلكتروني.',
      info_evidence_title: 'أدلة واضحة مطلوبة',
      info_evidence_text: 'التقط صورًا أو فيديوهات للمنتج مع ملصق الطلب أو الفاتورة.',
      info_review_title: 'مراجعة عادلة',
      info_review_text: 'سيقوم فريقنا بالمراجعة والرد بعد التحقق.',

      step_verify: 'تأكيد الطلب',
      step_details: 'تفاصيل المطالبة',
      step_evidence: 'الأدلة',
      step_submit: 'الإرسال',

      verify_heading: 'البحث عن الطلب',
      verify_help: 'أدخل رقم الطلب ورقم الجوال أو البريد الإلكتروني المستخدم في الطلب.',
      order_number: 'رقم الطلب',
      phone_email: 'رقم الجوال أو البريد الإلكتروني',
      find_order: 'البحث عن الطلب',

      claim_details_heading: 'اختر المنتج المتأثر',
      claim_details_help: 'يمكن اختيار المنتجات الموجودة في طلبك فقط.',
      affected_product: 'المنتج المتأثر',
      select_product: 'اختر المنتج',
      claim_reason: 'سبب المطالبة',
      select_reason: 'اختر السبب',
      reason_damaged: 'المنتج تالف',
      reason_spoiled: 'المنتج فاسد',
      reason_wrong: 'تم استلام منتج خاطئ',
      reason_missing: 'منتج ناقص',
      reason_quality: 'جودة غير مرضية',
      reason_quantity: 'مشكلة في الكمية',
      reason_other: 'أخرى',
      affected_quantity: 'الكمية المتأثرة',
      description: 'اشرح المشكلة',

      evidence_heading: 'التقاط الأدلة',
      evidence_help: 'يرجى التقاط صور أو فيديوهات واضحة باستخدام الكاميرا. لا يُسمح بالرفع من المعرض أو الكمبيوتر.',
      evidence_label_title: '١. المنتج مع ملصق الطلب أو الفاتورة',
      evidence_label_help: 'أظهر المنتج المتأثر مع ملصق الطلب أو الفاتورة.',
      evidence_closeup_title: '٢. صورة قريبة للمشكلة',
      evidence_closeup_help: 'أظهر صورة أو فيديو واضح للمشكلة في المنتج.',
      evidence_video_title: '٣. فيديو مباشر مطلوب',
      evidence_video_help: 'لهذه المطالبة، يلزم تسجيل فيديو مباشر لإكمال المراجعة.',
      take_photo: 'التقاط صورة',
      record_video: 'تسجيل فيديو',
      record_live_video: 'تسجيل فيديو مباشر',
      camera_required_note: 'التقاط الكاميرا مطلوب. لا يُسمح بالرفع من المعرض أو الكمبيوتر.',
      live_camera_required_note: 'تسجيل فيديو مباشر بالكاميرا مطلوب. لا يُسمح بالرفع من المعرض أو الكمبيوتر.',
      capture_photo: 'التقاط الصورة',
      cancel: 'إلغاء',
      start_recording: 'بدء التسجيل',
      stop_recording: 'إيقاف التسجيل',
      retake_photo: 'إعادة التقاط الصورة',
      record_again: 'تسجيل مرة أخرى',

      review_heading: 'المراجعة والإرسال',
      claim_notice: 'لمراجعة المطالبات بشكل عادل، قد تطلب Sharbatly.club صورًا أو فيديوهات تُظهر المنتج المتأثر مع ملصق الطلب أو الفاتورة. قد يتم رفض المطالبات التي تحتوي على أدلة غير واضحة أو معدلة أو معاد استخدامها أو ملفقة أو مضللة أو غير قابلة للتحقق. تحتفظ Sharbatly.club بالحق في تقييد أو تعليق الحسابات المرتبطة، وإلغاء الطلبات، واسترداد المبالغ أو الأرصدة التي تم الحصول عليها بشكل غير صحيح، واتخاذ إجراءات إضافية وفقًا للشروط والأحكام والقوانين المعمول بها.',
      confirm_accuracy: 'أؤكد أن المعلومات والأدلة المقدمة صحيحة وتتعلق بهذا الطلب.',

      back: 'رجوع',
      continue: 'متابعة',
      submit_claim: 'إرسال المطالبة',

      success_heading: 'تم إرسال المطالبة بنجاح',
      success_text: 'مطالبتك قيد المراجعة. يرجى الاحتفاظ بالمنتج المتأثر والتغليف وملصق الطلب والفاتورة حتى يكمل فريقنا المراجعة.',
      claim_id: 'رقم المطالبة',

      required_fields: 'يرجى تعبئة جميع الحقول المطلوبة.',
      order_not_found: 'تعذر التحقق من الطلب. يرجى التأكد من رقم الطلب ورقم الجوال أو البريد الإلكتروني.',
      outside_window: 'هذا الطلب خارج الفترة المسموحة لتقديم المطالبة.',
      upload_required: 'يرجى التقاط الأدلة المطلوبة باستخدام الكاميرا.',
      verifying: 'جاري التحقق...',
      submitting: 'جاري الإرسال...',
      uploading: 'جاري رفع الأدلة...',
      verified: 'تم التحقق من الطلب بنجاح.',
      max_quantity: 'لا يمكن أن تكون الكمية المتأثرة أكبر من الكمية المطلوبة.',
      file_selected: 'الملف الملتقط:',
      camera_not_supported: 'الكاميرا غير مدعومة في هذا المتصفح. يرجى فتح الصفحة من متصفح الجوال.',
      video_not_supported: 'تسجيل الفيديو غير مدعوم في هذا المتصفح. يرجى فتح الصفحة من متصفح الجوال.',
      camera_permission_required: 'يلزم السماح باستخدام الكاميرا لتقديم أدلة المطالبة.',
      capture_failed: 'تعذر التقاط الصورة. يرجى المحاولة مرة أخرى.',

      order: 'الطلب',
      delivered: 'تم التوصيل',
      city: 'المدينة',
      product: 'المنتج',
      reason: 'السبب',
      quantity: 'الكمية',
      evidence: 'الأدلة'
    }
  };

  const t = (key) => translations[isArabic ? 'ar' : 'en'][key] || key;

  const state = {
    step: 1,
    verifiedOrder: null,
    claimDraft: null,
    uploadedEvidence: [],
    capturedEvidence: {}
  };

  const form = document.getElementById('claimsForm');
  const alertBox = document.getElementById('claimsAlert');
  const verifyOrderBtn = document.getElementById('verifyOrderBtn');
  const submitClaimBtn = document.getElementById('submitClaimBtn');
  const claimedProduct = document.getElementById('claimedProduct');
  const claimedQuantity = document.getElementById('claimedQuantity');
  const claimDescription = document.getElementById('claimDescription');
  const descriptionCount = document.getElementById('descriptionCount');
  const orderSummary = document.getElementById('orderSummary');
  const reviewSummary = document.getElementById('reviewSummary');
  const claimSuccess = document.getElementById('claimSuccess');
  const successClaimId = document.getElementById('successClaimId');
  const liveVideoBlock = document.getElementById('liveVideoBlock');
  const uploadProgress = document.getElementById('uploadProgress');
  const uploadProgressFill = document.getElementById('uploadProgressFill');
  const uploadProgressText = document.getElementById('uploadProgressText');

  function applyTranslations() {
    root.querySelectorAll('[data-i18n]').forEach((el) => {
      const key = el.dataset.i18n;
      if (translations[isArabic ? 'ar' : 'en'][key]) {
        el.textContent = t(key);
      }
    });

    if (isArabic) {
      root.setAttribute('dir', 'rtl');
    }
  }

  function showAlert(message, type = 'error') {
    alertBox.hidden = false;
    alertBox.className = `claims-alert is-${type}`;
    alertBox.textContent = message;
    alertBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearAlert() {
    alertBox.hidden = true;
    alertBox.textContent = '';
  }

  function setButtonLoading(button, isLoading, loadingTextKey) {
    if (!button) return;

    const span = button.querySelector('span') || button;

    if (isLoading) {
      button.dataset.originalText = span.textContent;
      span.textContent = t(loadingTextKey);
      button.disabled = true;
    } else {
      span.textContent = button.dataset.originalText || span.textContent;
      button.disabled = false;
    }
  }

  function goToStep(step) {
    state.step = step;

    root.querySelectorAll('[data-step]').forEach((panel) => {
      panel.classList.toggle('is-active', Number(panel.dataset.step) === step);
    });

    root.querySelectorAll('[data-step-indicator]').forEach((indicator) => {
      indicator.classList.toggle(
        'is-active',
        Number(indicator.dataset.stepIndicator) === step
      );
    });

    clearAlert();

    if (step === 4) {
      renderReviewSummary();
    }

    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function validateStep(step) {
    if (step === 1) {
      const orderNumber = document.getElementById('orderNumber').value.trim();
      const contact = document.getElementById('customerContact').value.trim();

      if (!orderNumber || !contact) {
        showAlert(t('required_fields'));
        return false;
      }
    }

    if (step === 2) {
      const productValue = claimedProduct.value;
      const reason = document.getElementById('claimReason').value;
      const quantity = Number(claimedQuantity.value || 0);
      const selectedItem = getSelectedItem();

      if (!productValue || !reason || !quantity) {
        showAlert(t('required_fields'));
        return false;
      }

      if (selectedItem && quantity > Number(selectedItem.quantity)) {
        showAlert(t('max_quantity'));
        return false;
      }
    }

    if (step === 3) {
      const labelEvidence = state.capturedEvidence.product_with_label_or_invoice;
      const defectEvidence = state.capturedEvidence.defect_closeup;
      const liveVideoRequired = liveVideoBlock && !liveVideoBlock.hidden;
      const liveVideoEvidence = state.capturedEvidence.live_video;

      if (!labelEvidence || !defectEvidence || (liveVideoRequired && !liveVideoEvidence)) {
        showAlert(t('upload_required'));
        return false;
      }
    }

    if (step === 4) {
      const confirmation = document.getElementById('claimConfirmation').checked;
      if (!confirmation) {
        showAlert(t('required_fields'));
        return false;
      }
    }

    clearAlert();
    return true;
  }

  function getSelectedItem() {
    if (!state.verifiedOrder) return null;

    return state.verifiedOrder.items.find(
      (item) => String(item.line_item_id) === String(claimedProduct.value)
    );
  }

  function renderOrderSummary(order) {
    orderSummary.hidden = false;
    orderSummary.innerHTML = `
      <strong>${t('order')}: ${escapeHtml(order.order_number || order.orderNumber || '')}</strong>
      <p>${t('city')}: ${escapeHtml(order.city || '')}</p>
      <p>${t('delivered')}: ${formatDate(order.delivered_at || order.deliveredAt)}</p>
    `;
  }

  function populateProducts(order) {
    claimedProduct.innerHTML = `<option value="">${t('select_product')}</option>`;

    order.items.forEach((item) => {
      const option = document.createElement('option');
      option.value = item.line_item_id;
      option.dataset.quantity = item.quantity;
      option.textContent = `${item.product_title}${item.variant_title ? ` - ${item.variant_title}` : ''}${item.sku ? ` (${item.sku})` : ''}`;
      claimedProduct.appendChild(option);
    });
  }

  function renderReviewSummary() {
    const item = getSelectedItem();
    const reasonSelect = document.getElementById('claimReason');
    const reasonText = reasonSelect.options[reasonSelect.selectedIndex]?.textContent || '';

    const evidenceList = Object.keys(state.capturedEvidence)
      .map((key) => state.capturedEvidence[key]?.file?.name)
      .filter(Boolean)
      .map((name) => `<li>${escapeHtml(name)}</li>`)
      .join('');

    reviewSummary.innerHTML = `
      <p><strong>${t('order')}:</strong> ${escapeHtml(state.verifiedOrder?.order_number || state.verifiedOrder?.orderNumber || '')}</p>
      <p><strong>${t('product')}:</strong> ${escapeHtml(item?.product_title || '')}</p>
      <p><strong>${t('reason')}:</strong> ${escapeHtml(reasonText)}</p>
      <p><strong>${t('quantity')}:</strong> ${escapeHtml(claimedQuantity.value)}</p>
      ${evidenceList ? `<p><strong>${t('evidence')}:</strong></p><ul>${evidenceList}</ul>` : ''}
    `;
  }

  function maybeRequireLiveVideo() {
    const selectedItem = getSelectedItem();
    const reason = document.getElementById('claimReason').value;

    const highRiskReasons = ['spoiled_product', 'wrong_item'];
    const highValue = selectedItem && Number(selectedItem.price || 0) * Number(claimedQuantity.value || 1) >= 150;

    const requiresLiveVideo =
      Boolean(state.verifiedOrder?.requires_live_video) ||
      Boolean(selectedItem?.requires_live_video) ||
      (highRiskReasons.includes(reason) && highValue);

    if (liveVideoBlock) {
      liveVideoBlock.hidden = !requiresLiveVideo;
    }

    if (!requiresLiveVideo && state.capturedEvidence.live_video) {
      delete state.capturedEvidence.live_video;

      const previewBox = document.getElementById('preview_live_video');
      const textPreview = document.getElementById('liveVideoEvidencePreview');

      if (previewBox) {
        previewBox.hidden = true;
        previewBox.innerHTML = '';
      }

      if (textPreview) {
        textPreview.textContent = '';
      }
    }
  }

  async function verifyOrder() {
    if (!validateStep(1)) return;

    const orderNumber = document.getElementById('orderNumber').value.trim();
    const contact = document.getElementById('customerContact').value.trim();

    setButtonLoading(verifyOrderBtn, true, 'verifying');

    try {
      const result = mockMode
        ? await mockVerifyOrder(orderNumber, contact)
        : await postJson('/verify-order', { orderNumber, contact });

      if (!result || !result.eligible) {
        showAlert(result?.message || t('order_not_found'));
        return;
      }

      state.verifiedOrder = result.order;

      renderOrderSummary(result.order);
      populateProducts(result.order);
      showAlert(t('verified'), 'success');

      setTimeout(() => goToStep(2), 350);
    } catch (error) {
      console.error(error);
      showAlert(t('order_not_found'));
    } finally {
      setButtonLoading(verifyOrderBtn, false);
    }
  }

  async function submitClaim(event) {
    event.preventDefault();

    if (!validateStep(4)) return;

    const selectedItem = getSelectedItem();
    const order = state.verifiedOrder;

    const payload = {
      order_number: order.order_number || order.orderNumber,
      shopify_order_id: order.shopify_order_id || order.shopifyOrderId,
      customer: order.customer || {},
      city: order.city,
      delivered_at: order.delivered_at || order.deliveredAt,
      item: {
        line_item_id: selectedItem.line_item_id,
        product_id: selectedItem.product_id,
        variant_id: selectedItem.variant_id,
        sku: selectedItem.sku,
        product_title: selectedItem.product_title,
        variant_title: selectedItem.variant_title,
        quantity_ordered: selectedItem.quantity,
        quantity_claimed: Number(claimedQuantity.value),
        price: selectedItem.price
      },
      reason: document.getElementById('claimReason').value,
      description: claimDescription.value.trim(),
      language: isArabic ? 'ar' : 'en',
      source: 'shopify_claims_form'
    };

    setButtonLoading(submitClaimBtn, true, 'submitting');

    try {
      const claimDraft = mockMode
        ? await mockCreateClaim(payload)
        : await postJson('/claims', payload);

      state.claimDraft = claimDraft;

      await uploadAllEvidence(claimDraft.claim_id || claimDraft.claimId);

      const finalResult = mockMode
        ? await mockSubmitClaim(claimDraft.claim_id || claimDraft.claimId)
        : await postJson(`/claims/${encodeURIComponent(claimDraft.claim_id || claimDraft.claimId)}/submit`, {
            uploaded_evidence: state.uploadedEvidence
          });

      form.hidden = true;
      claimSuccess.hidden = false;

      successClaimId.textContent =
        finalResult.claim_number ||
        finalResult.claimNumber ||
        claimDraft.claim_number ||
        claimDraft.claimNumber ||
        claimDraft.claim_id ||
        claimDraft.claimId;
    } catch (error) {
      console.error(error);
      showAlert(error.message || 'Something went wrong. Please try again.');
    } finally {
      setButtonLoading(submitClaimBtn, false);
    }
  }

  async function uploadAllEvidence(claimId) {
    const evidenceFiles = [
      {
        role: 'product_with_label_or_invoice',
        captured: state.capturedEvidence.product_with_label_or_invoice
      },
      {
        role: 'defect_closeup',
        captured: state.capturedEvidence.defect_closeup
      },
      {
        role: 'live_video',
        captured: state.capturedEvidence.live_video
      }
    ].filter((item) => item.captured && item.captured.file);

    uploadProgress.hidden = false;
    uploadProgressFill.style.width = '0%';
    uploadProgressText.textContent = t('uploading');

    state.uploadedEvidence = [];

    for (let i = 0; i < evidenceFiles.length; i++) {
      const evidence = evidenceFiles[i];
      const file = evidence.captured.file;

      let uploadInfo;

      if (mockMode) {
        uploadInfo = await mockGetUploadUrl(claimId, evidence.role, file);
      } else {
        uploadInfo = await postJson(`/claims/${encodeURIComponent(claimId)}/upload-url`, {
          evidence_role: evidence.role,
          filename: file.name,
          content_type: file.type,
          size_bytes: file.size,
          capture_method: 'browser_camera'
        });
      }

      if (!mockMode) {
        await uploadFileWithProgress(
          uploadInfo.upload_url || uploadInfo.uploadUrl,
          file,
          (progress) => {
            const overallProgress = ((i + progress / 100) / evidenceFiles.length) * 100;
            uploadProgressFill.style.width = `${Math.round(overallProgress)}%`;
          }
        );
      } else {
        uploadProgressFill.style.width = `${Math.round(((i + 1) / evidenceFiles.length) * 100)}%`;
      }

      const evidenceCompletePayload = {
        evidence_id: uploadInfo.evidence_id || uploadInfo.evidenceId,
        storage_key: uploadInfo.storage_key || uploadInfo.storageKey,
        evidence_role: evidence.role,
        filename: file.name,
        content_type: file.type,
        size_bytes: file.size,
        capture_method: 'browser_camera'
      };

      if (!mockMode) {
        await postJson(`/claims/${encodeURIComponent(claimId)}/evidence-complete`, evidenceCompletePayload);
      }

      state.uploadedEvidence.push(evidenceCompletePayload);
    }

    uploadProgressFill.style.width = '100%';
  }

  async function postJson(path, body) {
    const response = await fetch(`${apiBaseUrl}${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Claims-Source': 'shopify-claims-form'
      },
      body: JSON.stringify(body)
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(data.message || data.error || `Request failed: ${response.status}`);
    }

    return data;
  }

  function uploadFileWithProgress(url, file, onProgress) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.open('PUT', url, true);
      xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream');

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable && typeof onProgress === 'function') {
          onProgress((event.loaded / event.total) * 100);
        }
      };

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve();
        } else {
          reject(new Error(`Upload failed: ${xhr.status}`));
        }
      };

      xhr.onerror = () => reject(new Error('Upload failed'));
      xhr.send(file);
    });
  }

  async function capturePhoto(role) {
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        showAlert(t('camera_not_supported'));
        return;
      }

      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: 'environment' }
        },
        audio: false
      });

      const video = document.createElement('video');
      video.setAttribute('playsinline', 'true');
      video.autoplay = true;
      video.muted = true;
      video.srcObject = stream;

      const previewBox = document.getElementById(`preview_${role}`);
      if (!previewBox) return;

      previewBox.hidden = false;
      previewBox.innerHTML = '';
      previewBox.appendChild(video);

      await video.play();

      const actions = document.createElement('div');
      actions.className = 'camera-actions';

      const captureButton = document.createElement('button');
      captureButton.type = 'button';
      captureButton.className = 'camera-btn';
      captureButton.textContent = t('capture_photo');

      const cancelButton = document.createElement('button');
      cancelButton.type = 'button';
      cancelButton.className = 'camera-btn camera-btn-secondary';
      cancelButton.textContent = t('cancel');

      actions.appendChild(captureButton);
      actions.appendChild(cancelButton);
      previewBox.appendChild(actions);

      cancelButton.onclick = () => {
        stopStream(stream);
        previewBox.hidden = true;
        previewBox.innerHTML = '';
      };

      captureButton.onclick = () => {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth || 1280;
        canvas.height = video.videoHeight || 720;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        canvas.toBlob((blob) => {
          if (!blob) {
            showAlert(t('capture_failed'));
            return;
          }

          const file = new File(
            [blob],
            `${role}-${Date.now()}.jpg`,
            { type: 'image/jpeg' }
          );

          state.capturedEvidence[role] = {
            file,
            type: 'photo'
          };

          stopStream(stream);
          renderCapturedPreview(role, file, 'photo');
          clearAlert();
        }, 'image/jpeg', 0.92);
      };
    } catch (error) {
      console.error(error);
      showAlert(t('camera_permission_required'));
    }
  }

  async function captureVideo(role) {
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !window.MediaRecorder) {
        showAlert(t('video_not_supported'));
        return;
      }

      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: 'environment' }
        },
        audio: true
      });

      const video = document.createElement('video');
      video.setAttribute('playsinline', 'true');
      video.autoplay = true;
      video.muted = true;
      video.srcObject = stream;

      const previewBox = document.getElementById(`preview_${role}`);
      if (!previewBox) return;

      previewBox.hidden = false;
      previewBox.innerHTML = '';
      previewBox.appendChild(video);

      await video.play();

      const chunks = [];
      const supportedMimeType = getSupportedVideoMimeType();
      const recorder = supportedMimeType
        ? new MediaRecorder(stream, { mimeType: supportedMimeType })
        : new MediaRecorder(stream);

      recorder.ondataavailable = (event) => {
        if (event.data && event.data.size > 0) {
          chunks.push(event.data);
        }
      };

      const actions = document.createElement('div');
      actions.className = 'camera-actions';

      const startButton = document.createElement('button');
      startButton.type = 'button';
      startButton.className = 'camera-btn';
      startButton.textContent = t('start_recording');

      const stopButton = document.createElement('button');
      stopButton.type = 'button';
      stopButton.className = 'camera-btn';
      stopButton.textContent = t('stop_recording');
      stopButton.disabled = true;

      const cancelButton = document.createElement('button');
      cancelButton.type = 'button';
      cancelButton.className = 'camera-btn camera-btn-secondary';
      cancelButton.textContent = t('cancel');

      actions.appendChild(startButton);
      actions.appendChild(stopButton);
      actions.appendChild(cancelButton);
      previewBox.appendChild(actions);

      startButton.onclick = () => {
        chunks.length = 0;
        recorder.start();
        startButton.disabled = true;
        stopButton.disabled = false;
      };

      stopButton.onclick = () => {
        if (recorder.state !== 'inactive') {
          recorder.stop();
        }
      };

      cancelButton.onclick = () => {
        if (recorder.state !== 'inactive') {
          recorder.stop();
        }

        stopStream(stream);
        previewBox.hidden = true;
        previewBox.innerHTML = '';
      };

      recorder.onstop = () => {
        if (!chunks.length) {
          stopStream(stream);
          return;
        }

        const mimeType = recorder.mimeType || supportedMimeType || 'video/webm';
        const blob = new Blob(chunks, { type: mimeType });
        const extension = mimeType.includes('mp4') ? 'mp4' : 'webm';

        const file = new File(
          [blob],
          `${role}-${Date.now()}.${extension}`,
          { type: mimeType }
        );

        state.capturedEvidence[role] = {
          file,
          type: 'video'
        };

        stopStream(stream);
        renderCapturedPreview(role, file, 'video');
        clearAlert();
      };
    } catch (error) {
      console.error(error);
      showAlert(t('camera_permission_required'));
    }
  }

  function renderCapturedPreview(role, file, type) {
    const previewBox = document.getElementById(`preview_${role}`);
    if (!previewBox) return;

    previewBox.hidden = false;
    previewBox.innerHTML = '';

    const url = URL.createObjectURL(file);

    if (type === 'photo') {
      const img = document.createElement('img');
      img.src = url;
      img.alt = 'Captured evidence';
      previewBox.appendChild(img);
    } else {
      const video = document.createElement('video');
      video.src = url;
      video.controls = true;
      video.playsInline = true;
      previewBox.appendChild(video);
    }

    const retakeButton = document.createElement('button');
    retakeButton.type = 'button';
    retakeButton.className = 'camera-btn camera-btn-secondary';
    retakeButton.style.marginTop = '12px';
    retakeButton.textContent = type === 'photo' ? t('retake_photo') : t('record_again');

    retakeButton.onclick = () => {
      delete state.capturedEvidence[role];

      if (type === 'photo') {
        capturePhoto(role);
      } else {
        captureVideo(role);
      }
    };

    previewBox.appendChild(retakeButton);

    const previewTextMap = {
      product_with_label_or_invoice: 'labelEvidencePreview',
      defect_closeup: 'defectEvidencePreview',
      live_video: 'liveVideoEvidencePreview'
    };

    const textPreview = document.getElementById(previewTextMap[role]);

    if (textPreview) {
      textPreview.textContent = `${t('file_selected')} ${file.name} (${formatFileSize(file.size)})`;
    }
  }

  function stopStream(stream) {
    if (!stream) return;
    stream.getTracks().forEach((track) => track.stop());
  }

  function getSupportedVideoMimeType() {
    const types = [
      'video/mp4',
      'video/webm;codecs=vp9',
      'video/webm;codecs=vp8',
      'video/webm'
    ];

    if (!window.MediaRecorder || !MediaRecorder.isTypeSupported) {
      return '';
    }

    return types.find((type) => MediaRecorder.isTypeSupported(type)) || '';
  }

  function formatFileSize(bytes) {
    if (!bytes) return '0 KB';

    const mb = bytes / 1024 / 1024;

    if (mb >= 1) {
      return `${mb.toFixed(1)} MB`;
    }

    return `${Math.round(bytes / 1024)} KB`;
  }

  function formatDate(value) {
    if (!value) return '-';

    try {
      return new Intl.DateTimeFormat(isArabic ? 'ar-SA' : 'en-SA', {
        dateStyle: 'medium',
        timeStyle: 'short'
      }).format(new Date(value));
    } catch {
      return value;
    }
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  async function mockVerifyOrder(orderNumber, contact) {
    await wait(500);

    return {
      eligible: true,
      order: {
        order_number: orderNumber,
        shopify_order_id: 'gid://shopify/Order/123456789',
        city: isArabic ? 'جدة' : 'Jeddah',
        delivered_at: new Date().toISOString(),
        requires_live_video: false,
        customer: {
          name: 'Test Customer',
          contact
        },
        items: [
          {
            line_item_id: '1001',
            product_id: '2001',
            variant_id: '3001',
            sku: 'APPLE-GALA-1KG',
            product_title: isArabic ? 'تفاح رويال جالا – عبوة 1 كجم' : 'Apple Royal Gala - 1 KG',
            variant_title: '',
            quantity: 2,
            price: 7.99,
            requires_live_video: false
          },
          {
            line_item_id: '1002',
            product_id: '2002',
            variant_id: '3002',
            sku: 'BANANA-1KG',
            product_title: isArabic ? 'موز الشربتلي – حزمة 1 كجم' : 'Sharbatly Banana - 1 KG',
            variant_title: '',
            quantity: 1,
            price: 4.5,
            requires_live_video: false
          }
        ]
      }
    };
  }

  async function mockCreateClaim() {
    await wait(400);

    return {
      claim_id: 'mock-claim-id',
      claim_number: `CLM-${new Date().toISOString().slice(0, 10).replaceAll('-', '')}-000001`
    };
  }

  async function mockGetUploadUrl(claimId, role, file) {
    await wait(300);

    return {
      evidence_id: `mock-${role}`,
      storage_key: `claims/${claimId}/${role}/${file.name}`,
      upload_url: '#'
    };
  }

  async function mockSubmitClaim() {
    await wait(500);

    return {
      claim_number: `CLM-${new Date().toISOString().slice(0, 10).replaceAll('-', '')}-000001`
    };
  }

  function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  verifyOrderBtn?.addEventListener('click', verifyOrder);
  form?.addEventListener('submit', submitClaim);

  root.querySelectorAll('[data-next-step]').forEach((button) => {
    button.addEventListener('click', () => {
      if (validateStep(state.step)) {
        goToStep(state.step + 1);
      }
    });
  });

  root.querySelectorAll('[data-prev-step]').forEach((button) => {
    button.addEventListener('click', () => {
      goToStep(Math.max(1, state.step - 1));
    });
  });

  claimDescription?.addEventListener('input', () => {
    descriptionCount.textContent = claimDescription.value.length;
  });

  claimedProduct?.addEventListener('change', () => {
    const selectedItem = getSelectedItem();

    if (selectedItem) {
      claimedQuantity.max = selectedItem.quantity;
      claimedQuantity.value = Math.min(
        Number(claimedQuantity.value || 1),
        Number(selectedItem.quantity)
      );
    }

    maybeRequireLiveVideo();
  });

  document.getElementById('claimReason')?.addEventListener('change', maybeRequireLiveVideo);
  claimedQuantity?.addEventListener('input', maybeRequireLiveVideo);

  root.querySelectorAll('[data-camera-photo]').forEach((button) => {
    button.addEventListener('click', () => {
      capturePhoto(button.dataset.cameraPhoto);
    });
  });

  root.querySelectorAll('[data-camera-video]').forEach((button) => {
    button.addEventListener('click', () => {
      captureVideo(button.dataset.cameraVideo);
    });
  });

  applyTranslations();
})();